import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyBwzeK_wTfD8HV9vtPv1z3WwdgJ602cEfI",
  authDomain: "asym2d.firebaseapp.com",
  projectId: "asym2d",
  storageBucket: "asym2d.appspot.com",
  messagingSenderId: "742242783124",
  appId: "1:742242783124:web:14010b48b372021a288981",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export default database;